import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowLeft, CircleX, Pencil, Plus } from "lucide-react";
import { supabase } from "../../supabase-client";

function Imagenes() {
   const location = useLocation();
   const { state } = location;
   const [tasks, setTasks] = useState([]);
   const [listadeimagenes, setListadeimagenes] = useState([]);
   const [taskImage, setTaskImage] = useState(null);
   const [imageRecord, setImageRecord] = useState(null);
   const [change, setChange] = useState(false);
   const [input, setInput] = useState({
      rec: state ? state.rec : [],
   });
   var maxOrden = 0
   console.log("rec: ", input);

   const fetchImagenes = async (id) => {
      const { error, data } = await supabase
         .from("muestraimagenes")
         .select("*")
         .eq("obra_id", input.rec.id)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading muestraimagenes: ", error.message);
         return;
      }

      console.log("fetchImagenes: ", data);
      setListadeimagenes(data);
   };
   const fetchTasks = async () => {
      const { error, data } = await supabase
         .from("tabla")
         .select("*")
         .eq("cod", 1)
         .gt("orden", 1)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading task: ", error.message);
         return;
      }

      setTasks(data);
   };

   useEffect(() => {
      fetchImagenes();
      fetchTasks();
   }, [change]);

   const uploadImage = async (file) => {
      const filePath = `${file.name}-${Date.now()}`;
      console.log("filePath: ", filePath);
      console.log("file: ", file);

      const { error } = await supabase.storage
         .from("diego-imagenes")
         .upload(filePath, file);

      if (error) {
         console.log("error: ", error);
         alert("Error uploading Image");
         return null;
      }
      const { data } = await supabase.storage
         .from("diego-imagenes")
         .getPublicUrl(filePath);

      console.log("Url creado: ", data.publicUrl);
      return data.publicUrl;
   };
const handleSaveImage = async () => {
   let imageUrl = null;
   
   // Validate required fields
   if (!imageRecord.texto.trim()) {
      imageRecord.texto = "-"; // Set default value if empty
   }
   
   if (taskImage) {
      console.log("Uploading new image...");
      imageUrl = await uploadImage(taskImage);
      
      if (!imageUrl) {
         alert("Error al subir la imagen. Intente nuevamente.");
         return;
      }
   }

   console.log("imageRecord.id: ", imageRecord);
   
   if (!imageRecord.id) {
      // 👈 For new records, imageUrl is required
      if (!imageUrl) {
         alert("Por favor seleccione una imagen");
         return;
      }
      
      const { id, ...newData } = imageRecord;
      const finalData = { 
         ...newData, 
         imagen_url: imageUrl, 
         orden: maxOrden + 1, // Use calculated maxOrden instead of hardcoded 1
         portada: imageRecord.portada ? 1 : 0,
      };
      
      const { error } = await supabase.from("muestraimagenes").insert(finalData);
      
      if (error) {
         console.log("error ", error);
         alert(`Error al crear imagen: ${error.message}`);
         return;
      }
      
      console.log("✅ Nueva imagen creada exitosamente");
   } else {
      // 👈 For updates, build update object conditionally
      const updateData = {
         texto: imageRecord.texto,
         orden: imageRecord.orden,
         obra_id: imageRecord.obra_id,
         estado: imageRecord.estado,
         portada: imageRecord.portada ? 1 : 0,
      };
      
      // Only update imagen_url if a new image was uploaded
      if (imageUrl) {
         updateData.imagen_url = imageUrl;
         console.log("✅ Updating image with new file");
      } else {
         console.log("✅ Updating image metadata only (no new file)");
      }
      
      const { error } = await supabase
         .from("muestraimagenes")
         .update(updateData)
         .eq("id", imageRecord.id);

      if (error) {
         console.log("error ", error);
         alert(`Error al actualizar imagen: ${error.message}`);
         return;
      }
      
      console.log("✅ Imagen actualizada exitosamente");
   }
   
   // Clear form and refresh
   setImageRecord(null);
   setTaskImage(null); // 👈 Clear the selected file
   
   // Clear file input
   const fileInput = document.querySelector('input[type="file"]');
   if (fileInput) {
      fileInput.value = '';
   }
   
   setChange(!change);
   console.log("Form cleared and data refreshed");
};
   // const handleSaveImage = async () => {
   //    let imageUrl = null;
   //    if (taskImage) {
   //       console.log("Cargo Imagen");
   //       imageUrl = await uploadImage(taskImage);
   //    }

   //    console.log("imageRecord.id: ", imageRecord);
   //    if (!imageRecord.id) {
   //       const { id, ...newData } = imageRecord;
   //       const finalData = { ...newData, imagen_url: imageUrl,orden:1 };
   //       const { error } = await supabase.from("muestraimagenes").insert(finalData);
   //       if (error) {
   //          console.log("error ", error);
   //          alert(error.message);
   //          return;
   //       }
   //    } else {
   //       const { error } = await supabase
   //          .from("muestraimagenes")
   //          .update({
   //             texto: imageRecord.texto,
   //             orden: imageRecord.orden,
   //             imagen_url: imageUrl,
   //             obra_id: imageRecord.obra_id,
   //             estado: imageRecord.estado,
   //          })
   //          .eq("id", imageRecord.id);

   //       if (error) {
   //          console.log("error ", error);
   //          alert(error.message);
   //          return;
   //       }
   //    }
   //    setImageRecord(null)
   //    setChange(!change)
   //    console.log("imageRecord: ", imageRecord);
   // };

   const handleFileChange = (e) => {
      if (e.target.files && e.target.files.length > 0) {
         setTaskImage(e.target.files[0]);
         console.log("lo hice");
      }
      console.log("e.target.files: ", e.target.files[0]);
   };
   const delImagen = async (url) => {
      const { data, error } = await supabase.storage
         .from("diego-imagenes")
         .remove(url);

      if (error) {
         alert("Error deleting image:");
         console.log("error.message: ", error.message);
         return null;
      }
      console.log("Image deleted successfully:", data);
      return data;
   };
   const handleDelete = async (datos) => {
      console.log("datos: ", datos);
      if (window.confirm("Esta seguro/a de eliminar esta Imagen?")) {
         delImagen(datos.imagen_url);

         const { error } = await supabase
            .from("muestraimagenes")
            .delete()
            .eq("id", datos.id);

         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      }
   };
   if (listadeimagenes.length===0){
      maxOrden=0;
   } else {
      maxOrden = Math.max(...listadeimagenes.map((item) => item.orden));
   }
   console.log('listadeimagenes: ', listadeimagenes.length);
   console.log("imageRecord: ", imageRecord,maxOrden);
   return (
      <>
         <div className="p-6 max-w-xl mx-auto">
            <div className="mt-6">
               <div className="flex justify-between">
                  <h2 className="text-lg font-semibold mb-3">
                     Muestrario Imagenes <b>{input.rec.titulo}</b>
                  </h2>
                  <button
                     onClick={() =>
                        setImageRecord({
                           id: 0,
                           imagen_url: "",
                           obra_id: input.rec.id,
                           orden: maxOrden + 1,
                           texto: "",
                           portada: 0,
                        })
                     }
                     className="btn-green"
                  >
                     <Plus className="lucid-icons-blue" /> Nuevo
                  </button>
               </div>
            </div>
            {listadeimagenes.length > 0 && (
               <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <thead className="bg-gray-200 text-gray-700">
                     <tr>
                        <th className="p-2 text-left">Titulo</th>
                        <th className="p-2 text-left">Imagen</th>
                        <th className="p-2 text-left">Portada</th>
                        <th className="p-2 text-left">Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {listadeimagenes.map((data) => (
                        <tr key={data.id} className="border-t hover:bg-gray-50">
                           <td className="p-2">{
                           (data.texto === "-") ? "" : data.texto
                           }</td>
                           <td className="p-2">
                              <img
                                 src={data.imagen_url}
                                 alt=""
                                 height="70px"
                                 width="90px"
                              ></img>
                           </td>
                           <td className="p-2">{
                           (data.portada===1) ? "Si" : "--"
                           }</td>
                           <td className="p-2 flex gap-2">
                              <button
                                 onClick={() =>
                                    setImageRecord({
                                       ...data,
                                       portada: data.portada ?? 0,
                                    })
                                 }
                                 className="btn-green"
                              >
                                 <Pencil className="lucid-icons-blue" /> Editar
                              </button>
                              <button
                                 onClick={() => handleDelete(data)}
                                 className="btn-red"
                              >
                                 <CircleX className="lucid-icons-red" /> Borrar
                              </button>
                              {/*<Link
                                 to="/admcuru/muestraimagenes"
                                 className="btn-purple"
                                 state={{
                                    rec: rec,
                                 }}
                              >
                                 <BookImage className="lucid-icons-blue" />{" "}
                                 Imagenes
                              </Link>
                              <button
                                 className="btn-purple"
                                 onClick={() => handleImages(rec.id)}
                              >
                                 <BookImage className="lucid-icons-blue" />{" "}
                                 Imagenes
                              </button> */}
                              &nbsp;
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </table>
            )}
         </div>
         {imageRecord && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
               <div className="bg-white p-6 rounded-lg shadow-lg w-2/4">
                  <h2 className="text-xl font-bold mb-4">Editar Imagen</h2>
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700  p-2 w-48">
                        Titulo (opcional)
                     </label>
                     <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        value={imageRecord.texto}
                        onChange={(e) =>
                           setImageRecord({
                              ...imageRecord,
                              texto: e.target.value,
                           })
                        }
                     />
                  </div>
                  {/* <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700  p-2 w-48">
                        Estado
                     </label>
                     <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        value={imageRecord.estado}
                        onChange={(e) =>
                           setImageRecord({
                              ...imageRecord,
                              estado: e.target.value,
                           })
                        }
                     />
                  </div> */}
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Estado
                     </label>
                     <select
                        value={imageRecord.estado}
                        // onChange={(e) => onChange(e.target.value)}
                        onChange={(e) =>
                           setImageRecord({
                              ...imageRecord,
                              estado: e.target.value,
                           })
                        }
                        className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm 
                                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 sm:text-sm"
                     >
                        <option value="">Seleccione...</option>
                        {tasks.map((item) => (
                           <option key={item.id} value={item.id}>
                              {item.descripcion}
                           </option>
                        ))}
                     </select>
                  </div>
                  <div className="flex items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Portada
                     </label>
                     <input
                        type="checkbox"
                        checked={Number(imageRecord.portada) === 1}
                        onChange={(e) =>
                           setImageRecord({
                              ...imageRecord,
                              portada: e.target.checked ? 1 : 0,
                           })
                        }
                        className="h-5 w-5"
                     />
                  </div>
                  {!imageRecord.id ? (
                     <div className="flex items-center">
                        <label className="block mb-2 text-sm font-medium text-gray-700  p-2 w-48">
                           Archivo
                        </label>
                        <input
                           type="file"
                           accept="image/*"
                           onChange={handleFileChange}
                        />
                     </div>
                  ) : (
                     <div>
                        <p>
                           Para cambiar la imagen primero elimine el registro en
                           la pantalla anterior
                        </p>
                     </div>
                  )}
                  <div className="flex justify-end gap-3">
                     <button
                        onClick={() => setImageRecord(null)}
                        className="btn-gray-light"
                     >
                        <ArrowLeft className="lucid-icons" /> Volver
                     </button>
                     <button onClick={handleSaveImage} className="btn-green">
                        <Plus className="lucid-icons-blue" /> Guardar
                     </button>
                  </div>
               </div>
            </div>
         )}
      </>
   );
}

export default Imagenes;
